import React from 'react'
import { View, ViewStyle } from 'react-native'
import { MeterProps } from './meter.props'
import { color } from '../../theme'

/**
 * Meter
 */
export function Meter(props: MeterProps) {
  const { value, style } = props

  const width = `${Math.round(value / 2)}%`

  return (
    <View style={{ ...CONTAINER, ...style }}>
      <View style={{ ...METER, width }} />
    </View>
  )
}

const CONTAINER: ViewStyle = {
  height: 12,
  borderRadius: 12,
  backgroundColor: color.shade10,
}
const METER: ViewStyle = {
  borderRadius: 12,
  flex: 1,
  backgroundColor: color.blue,
}
